import * as yup from "yup";


const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const schema = yup.object().shape({

    //Id : yup.string().required('Agent Id hasnt been generated'),
    Email:yup.string().required('Agent email address is required').email('Agent email is not formatted correctly'),
    Name:yup.string().required('Agent first name is required'),
    FamilyName:yup.string().required('Agent last name is requied'),
    UserName:yup.string().required('Agent UserName hasnt been generated'),
    Phone:yup.string().required('Agents phone number is required start with +'),
    Limit : yup.number().required('Limit cannot be empty').moreThan(0,'Limit cannot be 0'),
    Role : yup.string().required('User profile role must be selected'),
    Country : yup.string().required('Country must be selected'),
    //CountryCode : yup.string().required('Country must be selected'),
    //CurrencyCode : yup.string().required('Country must be selected'),
    //CurrencySymbol : yup.string().required('Country must be selected'),
    //CurrencyLabel : yup.string().required('Country must be selected'),
    AllowedExchanges: yup.array().of(yup.string()).required('Exchange type must be selected'),
    City : yup.string().required('City is required'),
    Address: yup.string().required('Address is required'),
});
